import { render, staticRenderFns } from "./NxCases.vue?vue&type=template&id=62b0e12a&scoped=true"
import script from "./NxCases.vue?vue&type=script&lang=js"
export * from "./NxCases.vue?vue&type=script&lang=js"
import style0 from "./NxCases.vue?vue&type=style&index=0&id=62b0e12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b0e12a",
  null
  
)

export default component.exports